<template>
  <div id="shared-user">
    <div style="position: relative;">
      <div :class="[isFocus ? 'user-focus' : 'user']">
        <hash-icon size="1.5x" class="custom-class"></hash-icon>
        <input class="input input--block" type="text" v-model="user" :placeholder="$t('sharedDrive.iberboxID')" autocomplete="off" @focus="focusOn" @blur="focusOff" :disabled="!isEditable">
        <chevron-down-icon v-if="isEditable" style="cursor: pointer;" size="1.5x" class="custom-class" @click="showMenu"></chevron-down-icon>
      </div>
      <nav id="menu-contactos" :style="menuStyle">
        <div style="display: block; border: none; text-align: left;">
          <contact v-for="(contacto) in contactos"
          :key="contacto.id"
          v-bind:name="contacto.name"
          v-bind:contact="user"
          @select-contact="selectContact"></contact>
        </div>
      </nav>
    </div>
    <select v-on:change="changePermissions" v-model="permissions">
      <option :value=0>{{ $t('settings.editor') }}</option>
      <option :value=1>{{ $t('settings.reader') }}</option>
    </select>
    <button style="border: none; background: none; display: flex; cursor: pointer;" @click="removeUser()">
      <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
    </button>
  </div>
</template>

<script>

import { HashIcon, Trash2Icon, ChevronDownIcon } from 'vue-feather-icons';
import Contact from '@/components/shared-drive/Contact.vue';

export default {
  name: 'shared-user',
  components: {
    HashIcon,
    Trash2Icon,
    ChevronDownIcon,
    Contact
  },
  data: function () {
    return {
      isFocus: false,
      user: '',
      isShowContacts: false,
      contactos: [],
      isSelectContact: false,
      permissions: '',
      isEditable: true
    };
  },
  async mounted () {
    if (this.name !== undefined) {
      this.isEditable = false;
    }
    this.user = this.name;
    if (this.accesslevel === undefined) {
      this.permissions = 0;
    } else {
      this.permissions = this.accesslevel;
    }
    this.fetchData();
  },
  watch: {
    user (val) {
      if (val === '') {
        this.isSelectContact = false;
      } 
      if (val !== '' && this.contactos.length > 0 && !this.isSelectContact) {
        this.isShowContacts = true;
      } else {
        this.isShowContacts = false;
      }
      this.$emit('update-value', val, this.index, this.permissions, this.handle);
    },
    contactsSelected() {
      this.fetchData();
    }
  },
  props: ['index', 'name', 'handle', 'contactsSelected', 'accesslevel'],
  computed: {
    menuStyle () {
      if (this.isShowContacts && this.contactos.length > 0) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    selectContact (nombre) {
      this.user = nombre;
      this.isShowContacts = false;
      this.isSelectContact = true;
      this.$emit('select-contact', nombre);
    },
    focusOn () {
      this.isFocus = true;
    },
    focusOff () {
      this.isFocus = false;
    },
    removeUser() {
      if (this.index !== 0) {
        this.$emit('remove-user', this.index);
      } else {
        this.user = '';
        this.isEditable = true;
        this.$emit('remove-user', this.index);
      }
    },
    async fetchData() {
      let action = await ibb.getRootNode(Module.NodeType.CONTACT_ROOT.value);
      if (action.error.type) {
        throw new Error('Error getting root node: ' +  action.error.type);
      }
      const {nodeList} = await ibb.getChildren(action.node.handle);
      let index = -1;
      for (let contact of nodeList) {
        if (contact.name === 'Contacto Externo') {
          index = nodeList.indexOf(contact);
        }
      }
      if (index > -1) {
        nodeList.splice(index, 1);
      }
      this.contactos = nodeList;

      if (this.contactsSelected.length > 0) {
        for (let value of this.contactsSelected) {
          let index = -1;
          for (let i = 0; i < this.contactos.length; i++) {
            if (value === this.contactos[i].name) {
              index = i;
            }
          }
          if (index > -1) {
            this.contactos.splice(index, 1);
          }
        }
      }
    },
    changePermissions() {
      this.$emit('update-value', this.user, this.index, this.permissions, this.handle);
    },
    async showMenu() {
      this.isShowContacts = !this.isShowContacts;
      this.$emit('scroll-users');
    }
  }
};
</script>